<div class="move-transfer-body">
  <sync-alert
    [type]="'warning'"
    [leadIcon]="'warning'"
    [showLeadIcon]="true"
    [title]="'Please do not close this.'"
    [description]="showDownloadAppUrl && downloadAppUrl"
    [showActions]="false"
    [showCloseButton]="false"
  />
  <div class="move-list body body-1" *ngIf="transferList.length">
    <p>
      {{ actionMoveOrCopy === webPathActionType.MOVE ? "Moved" : "Copied" }}
      {{ countCompleted }} out of {{ transferList.length }} items to "{{
        destinationName
      }}"
    </p>
  </div>
  <div class="transferring-list">
    <sync-list [ListItems]="transferList"> </sync-list>
  </div>
</div>
